import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

export type OptionalTypographyProps = TypographyProps;

const useStyles = makeStyles()(theme => ({
  disabled: {
    color: theme.palette.text.secondary,
  }
}));

export const OptionalTypography: React.FC<OptionalTypographyProps> = ({ children, className, ...props }) => {
  const l10n = useL10n();
  const { classes, cx } = useStyles();

  const isDisabled = children === null || children === undefined || children === '';
  const displayValue = isDisabled ? l10n.general.optional : children;

  return <Typography {...props} className={cx(className, { [classes.disabled]: isDisabled })}>{displayValue}</Typography>;
};
